"use client";
import { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    CircularProgress,
} from "@mui/material";
import { GetUserModel } from "../../services/Staff/StaffApi";
import { GetProjectModel } from "../../services/Project/projectApi";
import { getJobDetails } from "../../services/Job/JobApi";

export default function PreviewDialog({ open, onClose, jobKeyID }) {
    const [loading, setLoading] = useState(false);
    const [details, setDetails] = useState(null);

    useEffect(() => {
        if (!open || !jobKeyID) return;

        const fetchData = async () => {
            setLoading(true);
            try {
                const res = await getJobDetails(jobKeyID);
                setDetails(res.responseData.data || null);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [open, jobKeyID]);

    const Field = ({ label, value }) => (
        <div>
            <p className="text-[13px] font-semibold text-gray-800">{label}</p>
            <p className="text-[12px] text-gray-700 mt-0.5 break-all">
                {value ?? "—"}
            </p>
        </div>
    );

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            {/* Header */}
            <div className="bg-[#ECF6FF] px-6 py-4 border-b flex justify-between items-center">
                <h2 className="text-16 font-semibold">Job Details</h2>
                <button
                    className="text-gray-500 hover:text-gray-700"
                    onClick={onClose}
                >
                    ✕
                </button>
            </div>


            {/* Content */}
            <DialogContent className="p-6 bg-gray-50 max-h-[75vh] overflow-y-auto">

                {loading && (
                    <div className="flex justify-center py-20">
                        <CircularProgress />
                    </div>
                )}

                {!loading && !details && (
                    <p className="text-center text-gray-500 py-10">No details found.</p>
                )}

                {!loading && details && (
                    <div className="bg-white rounded-xl shadow p-6 border border-gray-200 space-y-8">

                        {/* ONE Combined Section */}
                        <div>
                            {/* <h3 className="text-[16px] font-semibold text-[#0F2944] mb-4">
                                Employee Information
                            </h3> */}

                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">

                                {/* Basic Information */}
                                <Field label="Job Name" value={details.jobName} />
                                <Field label="Project Name" value={details.projectName || "sadasd"} />
                                <Field label="Client" value={details.clientName} />
                                <Field label="Job Category" value={details.categoryName} />
                                <Field
                                    label="Start Date"
                                    value={details?.startDate?.split("T")[0] || "—"}
                                />
                                <Field
                                    label="End Date"
                                    value={details?.endDate?.split("T")[0] || "—"}
                                />
                                <Field
                                    label="Job Status"
                                    value={details.jobStatusName || "—"}
                                />
                                

                                <Field
                                    label="Assigned TL Name"
                                    value={
                                        Array.isArray(details.assignedTLName)
                                            ? details.assignedTLName.join(", ")
                                            : details.assignedTLName || "—"
                                    }
                                />
                                

                                <Field
                                    label="Assigned Team"
                                    value={
                                        Array.isArray(details.assignedTeamName)
                                            ? details.assignedTeamName.join(", ")
                                            : details.assignedTeamName || "—"
                                    }
                                />
                                {/* <Field
                                    label="Assigned TL"
                                    value={details.assignedTL?.length ? details.assignedTL.join(", ") : "—"}
                                />
                                <Field
                                    label="Site Engineer"
                                    value={details.siteEngineer?.length ? details.siteEngineer.join(", ") : "—"}
                                /> */}
                                {/* Media Attachment */}
                                <Field
                                    label="Media Attachment"
                                    value={
                                        details?.imageURL ? (
                                            <a
                                                href={details.imageURL}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-blue-600 underline"
                                            >
                                                View File
                                            </a>
                                        ) : "—"
                                    }
                                />

                            </div>
                        </div>

                    </div>
                )}
            </DialogContent>

            {/* Footer */}
            <div className="sticky bottom-0 bg-white border-t z-20">
                <div className="flex justify-end p-4">
                    <button
                        onClick={onClose}
                        className="mx-2 px-4 py-2 bg-gray-300 rounded-md text-12"
                    >
                        Close
                    </button>
                </div>
            </div>
        </Dialog>
    );
}
